import { hotContent, latestUpdates, featuredContent } from "./home";

const allShows = [...hotContent, ...latestUpdates, ...featuredContent];

export function getArticleById(id: number) {
  const show = allShows.find((s) => s.id === id);
  if (!show) return null;
  return {
    ...show,
    fullDescription:
      `${show.description}。该节目自播出以来备受观众喜爱，每期都有精彩内容呈现。节目制作团队精心策划，邀请众多明星嘉宾参与，为观众带来无与伦比的视听盛宴。无论是笑料不断的游戏环节，还是感人至深的真情流露，都让这档节目成为当下最受欢迎的综艺之一。每周准时更新，高清画质流畅播放，让您不错过任何一个精彩瞬间。`,
    publishDate: show.date,
    source: "6789影视原创",
    tags: [show.category, "综艺", "热门", "高清", "免费"],
    relatedShows: allShows
      .filter((s) => s.id !== id && s.category === show.category)
      .slice(0, 4),
  };
}

export function getRelatedArticles(categorySlug: string, excludeId: number) {
  return hotContent
    .filter((s) => s.categorySlug === categorySlug && s.id !== excludeId)
    .slice(0, 4);
}